export default "__VITE_ASSET__3ce4c1fb__"